import { render, staticRenderFns } from "./CreateStudySetSuccessModal.vue?vue&type=template&id=e6ec398a&scoped=true&"
import script from "./CreateStudySetSuccessModal.vue?vue&type=script&lang=js&"
export * from "./CreateStudySetSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateStudySetSuccessModal.vue?vue&type=style&index=0&id=e6ec398a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ec398a",
  null
  
)

export default component.exports